import React from "react";
import { AlertTitle, Alert } from "@material-ui/lab";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export default function EUserDetails({E_VERIFICATION_FAILURE_ALERT_CONTENT}) {
  const {t:Errorlabels, ready: errorLabelReady} = useTranslation("label-E_SIGNUP_FAILURE_SCENARIOS");
  const useStyles = makeStyles((theme)=>({
    AlertStyles: {
        padding: "0rem 0.25rem !important",
        color:theme.palette.eInformation.dark,
        backgroundColor:theme.palette.eInformation.light,
        margin: '1rem 0rem',
        "& .MuiAlert-icon":{
          marginRight:"5px "
        }
    },
    contentStyles:{
      overflowWrap : 'anywhere'
    }
  }));
  const classes = useStyles();
  return (
    <Alert severity="info" className={classes.AlertStyles}>
      <AlertTitle>
        <Typography variant="body1" align="left">
         <strong>{errorLabelReady ? Errorlabels("E_MATCH_FOUND") : ''}</strong>
        </Typography>
      </AlertTitle>
      <Typography
        variant="subtitle2"
        align="left"
        className={classes.contentStyles}
        dangerouslySetInnerHTML={{
          __html: E_VERIFICATION_FAILURE_ALERT_CONTENT,
        }}
      />
    </Alert>
  );
}
